<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-list v-for="client in clients" v-bind:key="client.id">
              <v-list-tile v-if="!client.hidden" @click="populateAreas(client.name)">
                <v-list-tile-action>
                  <v-icon color="primary">folder</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ client.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list v-for="areaFilter in filteredAreas" v-bind:key="areaFilter.area">
              <router-link tag="v-list-tile" :to="'/planner/list/' + areaFilter.assignmentIds.join(',')">
                <v-list-tile-action>
                  <v-icon color="primary">folder</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ areaFilter.area }}</v-list-tile-title>
                </v-list-tile-content>
              </router-link>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import {assignmentService} from "@/services/planner";


export default {
  name: "worklistPlanner",
  data: () => ({
    clients: [],
    filteredAreas: [],
    selectedClient: undefined,
  }),
  methods: {
    populateClientList() {
      assignmentService.resolveClients()
          .then(result => {
            this.clients = result.data.content;
          })
    },
    populateAreas(clientName) {
      assignmentService.resolveAreas(clientName)
          .then(result => {
            this.filteredAreas = result.data;
            this.clients = [];
          });
    }
  },
  computed: {
    showClientSelection() {
      if (this.selectedClient) {
        return false;
      } else {
        return true;
      }
    },
    resolveAreas() {
      if (this.selectedClient) {
        return this.selectedClient.areas;
      } else {
        return [];
      }
    }
  },
  created() {
    this.populateClientList();
  }
};
</script>
